import UILink from 'UIComponents/link/UILink';
import styled from 'styled-components';
import { getNavigateToTicketRecord } from 'conversations-thread-view/tickets/constants/Events';
import FormattedMessage from 'I18n/components/FormattedMessage';
import RecordLink from 'crm-links/record/RecordLink';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledRecordLink = styled(RecordLink).withConfig({
  displayName: "TicketName__StyledRecordLink",
  componentId: "sc-12e9o9h-0"
})(["line-height:20px;font-size:16px;", " max-width:fit-content;@media screen and (max-width:1500px){max-width:400px;}@media screen and (max-width:2000px) and (min-width:1501px){max-width:550px;}@media screen and (min-width:2001px){max-width:1150px;}"], ({
  textColor
}) => textColor ? `color: ${textColor};` : '');
const StyledLink = styled(UILink).withConfig({
  displayName: "TicketName__StyledLink",
  componentId: "sc-12e9o9h-1"
})(["line-height:20px;font-size:16px;", " max-width:fit-content;@media screen and (max-width:1500px){max-width:400px;}@media screen and (max-width:2000px) and (min-width:1501px){max-width:550px;}@media screen and (min-width:2001px){max-width:1150px;}"], ({
  textColor
}) => textColor ? `color: ${textColor};` : '');
const TicketName = ({
  includeEschref,
  ticketId,
  ticketName,
  ticketRecordLink,
  linkColor,
  trackEvent,
  useFlex
}) => {
  const subject = ticketName === '' ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "svh-workspace-ui-lib.ticket-header.noTicketName"
  }) : ticketName;
  if (includeEschref) {
    return /*#__PURE__*/_jsx("span", {
      "data-test-id": "ticket-header-name-link",
      children: /*#__PURE__*/_jsx(StyledRecordLink, {
        LinkComponentProps: {
          truncate: true,
          truncateStringProps: {
            useFlex
          }
        },
        includeEschref: true,
        objectId: ticketId,
        objectTypeId: "0-5",
        onTrackClick: () => trackEvent(getNavigateToTicketRecord(true)),
        textColor: linkColor,
        children: subject
      })
    });
  }
  return /*#__PURE__*/_jsx(StyledLink, {
    external: true,
    href: ticketRecordLink,
    onClick: () => trackEvent(getNavigateToTicketRecord(true)),
    truncate: true,
    truncateStringProps: {
      useFlex
    },
    "data-test-id": "ticket-header-name-link",
    textColor: linkColor,
    children: subject
  });
};
TicketName.displayName = 'TicketName';
export default TicketName;